import React from 'react';
import PropTypes from 'prop-types';

export default class Step extends React.Component {
  static propTypes = {
    children: PropTypes.any
  }

  goBackward = () => {
    return true;
  }

  goForward = () => {
    return true;
  }

  render() {
    let content = React.cloneElement(this.props.children, this.props);
    return (
      <div>
        {content}
      </div>
    );
  }
}
